





























import Vue, { PropType } from 'vue';
import { v4 } from 'uuid';

export type optionsType = {
  value: number;
  text: string;
};

export default Vue.extend({
  name: 'GSelectForm',
  props: {
    isLabel: { type: Boolean as PropType<boolean>, default: true },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
    value: { type: Number as PropType<number> },
    label: { type: String as PropType<string>, required: true },
    placeholder: { type: String as PropType<string>, default: '' },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    rules: { type: [String, Object] as PropType<string | object>, default: '' },
    isNotArrow: { type: Boolean as PropType<boolean>, default: false },
    name: { type: String as PropType<string>, required: true },
    options: { type: Array as PropType<optionsType[]>, required: true },
  },
  computed: {
    vid(): string {
      return `${this.name}:${v4()}`;
    },
    innerValue: {
      get(): number {
        return this.value;
      },
      set(val: number): void {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    validate() {
      (this.$refs.gSelectFormProvider as any).validate();
    },
  },
});
